module.exports = __webpack_public_path__ + "img/pay.17c2ff98.svg";